const logs = {
    page_title: '審計日誌',
    title: '審計日誌',
    subtitle: '查看使用者行為和事件',
    event: '事件',
    user: '使用者',
    application: '應用程式',
    time: '時間',
    filter_by: '過濾',
    last_1_hour: '最近 1 小時',
    last_24_hours: '最近 24 小時',
    last_7_days: '最近 7 天',
    last_30_days: '最近 30 天',
    custom_range: '自訂範圍',
    from: '從',
    to: '至',
};
export default Object.freeze(logs);
